<template>
  <el-container>
    <header class="page-header">
      <el-header class="header-menu">
        <head-bar :showCollapse="false" :activeValue="active"></head-bar>
      </el-header>
      <div class="content-header">
        <el-form :inline="true" size="small" label-width="80px">
          <el-form-item label="处理进度">
            <el-select clearable v-model="search.searchFields.operation_status" placeholder="请选择">
              <el-option
                v-for="item in operation_status_list"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="search-button-container">
          <el-button class="search-button" type="primary" icon="el-icon-search" size="small" @click="getIntegralMoneyList(1)">查询</el-button>
          <el-button size="small" @click="clearSearch" plain>重置</el-button>
          <el-button type="primary" size="small" @click="handleBatch(3)">批量拒绝</el-button>
          <el-button type="primary" size="small" @click="handleBatch(2)">批量通过</el-button>
        </div>
      </div>
    </header>
    <el-container>
      <div class="content">
        <div class="main" ref="main">
          <el-checkbox-group v-model="integralIdList">
            <el-card class="item" v-for="(item, index) of list" :key="item.id" :ref="`item${item.id}`">
              <el-descriptions :column="2" size="small">
                <el-checkbox slot="title" :label="item.id">{{ item.name }}</el-checkbox>
                <el-descriptions-item label="积分消耗">{{item.integral_num}}</el-descriptions-item>
                <el-descriptions-item label="现金金额">{{item.money}}</el-descriptions-item>
                <el-descriptions-item label="处理状态">{{item.operation_status_msg}}</el-descriptions-item>
                <el-descriptions-item label="申请日期">{{formatDate(Number(item.create_time) * 1000, 'YYYY.MM.DD').dateString}}</el-descriptions-item>
              </el-descriptions>
            </el-card>
          </el-checkbox-group>
        </div>
      </div>
    </el-container>
  </el-container>
</template>
<script>
import headBar from '@/components/frames/mobileHeadBar'
import {throttle, formatDate} from '@/libs/utils'
import { BAApi } from '@/api'

export default {
  data: () => ({
    search: {
      searchFields: {
        page: 1,
        count: 20,
        operation_status: 1,
        page: 1,
        count: 20,
        myList: [],
        hasMore: true,
        noData: false
      }
    },
    list: [],
    active: 'mobileIntegralMoney',
    operation_status_list: [
      {
        code: 0,
        value: '全部'
      },
      {
        code: 1,
        value: '待处理'
      },
      {
        code: 2,
        value: '处理成功'
      },
      {
        code: 3,
        value: '拒绝发放'
      }
    ],
    integralIdList: []
  }),
  components: {
    headBar
  },
  methods: {
    formatDate: formatDate,
    checkStatus: value => {
      switch (Number(value)) {
        case 1:
          return '待审核'
        case 2:
          return '审核通过'
        case 3:
          return '审核作废'
        case 4:
          return '审核拒绝'
        default:
          break
      }
    },
    clearSearch() {
      this.search = {
        searchFields: Object.assign({ count: this.search.searchFields.count }, {
          page: 1,
          operation_status: 1
        })
      }
    },
    // get data
    async getIntegralMoneyList(page) {
      this.search.searchFields.page = page || this.search.searchFields.page
      let params = {...this.search.searchFields}
      try {
        let data = (await BAApi.getIntegralMoneyList(params)).data
        if (data.code === 0) {
          this.$validator.reset()
          if (this.search.searchFields.page === 1) {
            this.search.searchFields.myList = []
          }
          const newList = data.receipt_list || []
          if (newList.length >= this.search.searchFields.count) {
            this.search.searchFields.hasMore = true
          } else {
            this.search.searchFields.hasMore = false
          }
          this.search.searchFields.myList = this.search.searchFields.myList.concat(newList)
          if (this.search.searchFields.myList.length === 0 && this.search.searchFields.page === 1) {
            this.search.searchFields.noData = true
          } else {
            this.search.searchFields.noData = false
          }
          this.list = this.search.searchFields.myList
        } else {
          this.$error(data)
        }
      } catch (err) {
        console.error(err)
      }
    },
    handleBatch(type) {
      let data = this.integralIdList
      if (data.length > 0) {
        let params = {
          money_ids: data.join(','),
          operation_status: type
        }
        let tip = `确定全部${type === 2 ? '成功' : '拒绝'}？`
        return this.$confirm(tip, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.changeStatus(params)
          })
      } else {
        this.$message.error('请先进行选择')
        return
      }
    },
    async changeStatus(params) {
      let loading = this.$loading()
      try {
        let data = (await BAApi.integralMoneyUpdate(params)).data
        if (data.code === 0) {
          this.$message.success('审核成功')
          this.getIntegralMoneyList()
        } else {
          this.$error(data)
        }
      } catch (err) {
        console.error(err)
      } finally {
        loading.close()
      }
    },
  },

  mounted() {
    window.scrollTo(0, 1)
    this.getIntegralMoneyList()
    let that = this
    window.onscroll = throttle(function () {
      const scrollHeight = document.body.scrollHeight
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      const offsetHeight = document.body.offsetHeight
      if (scrollHeight - (scrollTop + offsetHeight) <= 150 && that.search.searchFields.hasMore) {
        that.search.searchFields.page ++
        that.getIntegralMoneyList()
      }
    }, 1000, true)
  },
  beforeDestroy() {
    window.onscroll = null
  }
}
</script>

<style lang="less" scoped>
.page-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  z-index: 9;
  .content-header {
    margin-top: 15px;
    overflow: hidden;
    .search-button-container {
      float: right;
      padding-right: 15px;
      .search-button {
        margin-left: 15px;
      }
    }
  }
  .header-menu {
    height: auto!important;
  }
}
.content {
  margin-top: 220px;
  .button-field {
    padding-left: 15px;
  }
  .main {
    padding: 15px;
    .item {
      margin-bottom: 15px;
      .foot {
        height: 25px;
        padding-top: 10px;
        text-align: center;
        font-size: 12px;
        font-weight: 700;
        color: #409EFF;
      }
    }
  }
}
.content-header /deep/ .el-select {
  width: 260px;
}
.content-header /deep/ .el-input {
  width: 260px;
}
.el-menu-demo {
  overflow-x: scroll;
  display: flex;
}
</style>
<style lang="less">
.el-message-box {
  width: 360px;
}
</style>


